import { Component, OnInit } from '@angular/core';
import { RouteInfo } from './sidebar.metadata';
import { AuthenticationService } from '../../authentication/_services/authentication.service';

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: any[];
  menu_routes: RouteInfo[] = [];

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private authenticationService: AuthenticationService
  ) {}

  // End open close
  ngOnInit() {
    this.sidebarnavItems = this.authenticationService.menuSidebar;
  }
}
